<template>
  <div v-if="remission">
    <TopBarTitleComponent title="Guía de Remisión" :showBackIcon="true">
      <template slot="right-area">
        <div class="d-flex justify-content-end align-items-center">
          <el-dropdown
            @command="handleCommand"
            class="dropdown-theme-gray-outline d-flex align-items-center mr-4"
          >
            <span class="el-dropdown-link">
              <span class="ml-2">Opciones</span>
              <i class="el-icon-arrow-down el-icon--right mr-2"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template
                v-if="
                  remission.status === 'draft' || remission.status === 'failed'
                "
              >
                <el-dropdown-item command="edit"
                  ><img :src="iconEdit" alt="" /> Editar</el-dropdown-item
                >
              </template>
              <template v-if="remission.status === 'success'">
                <el-dropdown-item command="nuled"
                  ><img :src="iconNuled" alt="" /> Anular</el-dropdown-item
                >
              </template>
              <el-dropdown-item
                v-if="
                  remission.status !== 'success' && remission.status !== 'nuled'
                "
                command="delete"
              >
                <img :src="iconDelete" alt="" /> Eliminar
              </el-dropdown-item>
              <el-dropdown-item command="send"
                ><img :src="iconSend" alt="" /> Enviar
                documento</el-dropdown-item
              >
              <el-dropdown-item command="download">
                <i class="el-icon-download"></i> Descargar PDF
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <ButtonPrimaryComponent
            v-if="
              remission.status !== 'success' && remission.status !== 'nuled'
            "
            title="Firmar"
            @onSaveClick="sriModalVisible = true"
          />
        </div>
      </template>
    </TopBarTitleComponent>

    <b-container fluid class="pb-4 px-lg-4 pt-4">
      <!-- SRI Message alert -->
      <b-row v-if="remission.sri_sign_message">
        <b-col>
          <AlertInfoComponent
            title="Notificación SRI"
            type="error"
            class="mb-4"
            :description="remission.sri_sign_message"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <div class="card box-shadow card-quotes-view py-4">
            <div class="card-body">
              <!-- Header -->
              <div class="card-quotes-view-header">
                <div class="dvh-desktop">
                  <div class="dvh-desktop-top">
                    <div class="dvh-desktop-identity">
                      <div class="dvh-desktop-logo">
                        <business-logo />
                      </div>
                      <div class="dvh-desktop-identity-info">
                        <p class="dvh-desktop-doc-number">
                          N°&nbsp;{{ remission.number_remission }}
                        </p>
                        <p class="dvh-desktop-business-name">
                          {{ getUser.user_business.social_reason }}
                        </p>
                        <p class="dvh-desktop-business-detail">
                          RUC: {{ getUser.user_business.business_ruc }}
                        </p>
                      </div>
                    </div>
                    <div
                      v-if="remission.access_key"
                      class="dvh-desktop-sri-col"
                    >
                      <p class="dvh-desktop-sri-title">Autorización SRI</p>
                      <div
                        v-if="remission.sign_mode"
                        class="dvh-desktop-sri-row"
                      >
                        <span class="dvh-desktop-label">Ambiente</span>
                        <span
                          :class="[
                            'dvh-desktop-sri-env',
                            remission.sign_mode === 2 ? 'env-prod' : 'env-dev'
                          ]"
                        >
                          {{
                            remission.sign_mode === 2
                              ? "Producción"
                              : "Desarrollo"
                          }}
                        </span>
                      </div>
                      <div class="dvh-desktop-sri-row">
                        <span class="dvh-desktop-label"
                          >Número / Clave de acceso</span
                        >
                        <span class="dvh-desktop-sri-code">{{
                          remission.access_key
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="dvh-desktop-divider"></div>

                  <div class="dvh-desktop-meta-grid">
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Fecha de emisión</span>
                      <span class="dvh-desktop-value">{{
                        remission.emission_date_for_view
                      }}</span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Punto de emisión</span>
                      <span
                        class="dvh-desktop-value"
                        v-if="remission.emission_point"
                      >
                        {{ remission.emission_point.code }}
                      </span>
                    </div>
                    <div class="dvh-desktop-meta-cell">
                      <span class="dvh-desktop-label">Estado</span>
                      <StatusReadDocumentsComponent
                        :status.sync="remission.status"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <hr class="my-4" />

              <!-- Transport info -->
              <b-row>
                <b-col sm="12" md="6">
                  <h6 class="font-bold text-color-primary mb-3">
                    Transportista
                  </h6>
                  <p class="m-0">
                    <strong>{{ remission.carrier_name }}</strong>
                  </p>
                  <p class="m-0">RUC: {{ remission.carrier_ruc }}</p>
                  <p class="m-0">Placa: {{ remission.carrier_plate }}</p>
                  <p class="m-0 mt-2">
                    Salida: {{ remission.transport_start_date }}
                  </p>
                  <p class="m-0">Llegada: {{ remission.transport_end_date }}</p>
                  <p class="m-0">Origen: {{ remission.departure_address }}</p>
                </b-col>
                <b-col sm="12" md="6">
                  <h6 class="font-bold text-color-primary mb-3">
                    Destinatario
                  </h6>
                  <p class="m-0">
                    <strong>{{ remission.destination_name }}</strong>
                  </p>
                  <p class="m-0">ID: {{ remission.destination_id }}</p>
                  <p class="m-0">
                    Dirección: {{ remission.destination_address }}
                  </p>
                  <p class="m-0">Motivo: {{ remission.transfer_reason }}</p>
                  <p class="m-0" v-if="remission.route">
                    Ruta: {{ remission.route }}
                  </p>
                </b-col>
              </b-row>

              <hr class="my-4" />

              <!-- Supporting doc -->
              <b-row v-if="remission.supporting_doc_number">
                <b-col>
                  <h6 class="font-bold text-color-primary mb-2">
                    Documento Sustento
                  </h6>
                  <p class="m-0">
                    Tipo: {{ remission.supporting_doc_type }} | N°:
                    {{ remission.supporting_doc_number }} | Fecha:
                    {{ remission.supporting_doc_date }}
                  </p>
                </b-col>
              </b-row>

              <hr class="my-4" />

              <!-- Items -->
              <h6 class="font-bold text-color-primary mb-3">Mercadería</h6>
              <div class="card-quotes-view-table table-items">
                <b-row class="table-items-header">
                  <b-col md="2"
                    ><h6 class="h6 font-bold mb-0 ml-2">Código</h6></b-col
                  >
                  <b-col md="8"
                    ><h6 class="h6 font-bold mb-0">Descripción</h6></b-col
                  >
                  <b-col md="2"
                    ><h6 class="h6 font-bold mb-0">Cantidad</h6></b-col
                  >
                </b-row>
              </div>
              <b-row v-for="(item, i) in remission.items" :key="i" class="mt-3">
                <b-col md="2"
                  ><p class="m-0 ml-2">{{ item.item_code }}</p></b-col
                >
                <b-col md="8">
                  <p
                    v-for="(line, li) in descriptionLines(
                      item.item_description
                    )"
                    :key="li"
                    class="m-0"
                  >
                    {{ line }}
                  </p>
                </b-col>
                <b-col md="2"
                  ><p class="m-0">{{ item.quantity }}</p></b-col
                >
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- Firmar modal -->
    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="remission ? remission.number_remission : ''"
      :clientName="remission ? remission.destination_name || '' : ''"
      :amount="0"
      @confirm="signRemission"
    />

    <!-- Anular modal -->
    <el-dialog width="35%" title="" :visible.sync="nuledModalVisible">
      <div class="wrapper__invoice-nuled text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-color-primary mt-4">
          ¿Seguro desea anular la guía de remisión?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso, anúlela también en el <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <!-- Eliminar modal -->
    <el-dialog width="35%" title="" :visible.sync="deleteModalVisible">
      <div class="wrapper__invoice-delete text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-color-primary mt-4">
          ¿Seguro desea eliminar esta guía de remisión?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="remission.email ? [remission.email] : []"
      :toPhone="''"
      :recipientName="remission ? remission.destination_name || '' : ''"
      :messageableType="'remission'"
      :messageableId="$route.params.id"
      :moduleType="'remission'"
      :draftKey="'draft-remission-' + $route.params.id"
    />
  </div>
</template>

<script>
import BusinessLogo from "@/components/Business/BusinessLogo";
import AlertInfoComponent from "@/components/Alerts/Info";
import TopBarTitleComponent from "../../../../components/TopBarTitle";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import StatusReadDocumentsComponent from "../../../../components/StatusReadDocuments";
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import remissionService from "../services/remissionService";
import { downloadFile } from "@/assets/utils/files";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend
} from "@/services/resources";

export default {
  name: "RemissionViewPage",
  components: {
    TopBarTitleComponent,
    ButtonPrimaryComponent,
    AlertInfoComponent,
    StatusReadDocumentsComponent,
    BusinessLogo,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  },
  data: () => ({
    icoNotifyDanger,
    iconEdit,
    iconDelete,
    iconNuled,
    iconSend,
    remission: null,
    sriModalVisible: false,
    nuledModalVisible: false,
    deleteModalVisible: false,
    visibleDocumentSend: false
  }),
  computed: {
    getUser() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    // item_description guarda "Nombre\nDetalle": lo separo en líneas para
    // mostrar nombre y detalle apilados (como en factura).
    descriptionLines(desc) {
      const lines = (desc || "").toString().split("\n");
      return lines.length ? lines : [""];
    },
    handleCommand(command) {
      switch (command) {
        case "edit":
          this.$router.push({
            name: "sales.remissions.edit",
            params: { id: this.remission.id }
          });
          break;
        case "nuled":
          this.nuledModalVisible = true;
          break;
        case "delete":
          this.deleteModalVisible = true;
          break;
        case "send":
          this.visibleDocumentSend = true;
          break;
        case "download":
          this.downloadPDF();
          break;
      }
    },
    async downloadPDF() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { number_remission, id } = this.remission;
        const response = await remissionService
          .remissionDownload({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(response.data, `GuiaRemision - #${number_remission}`);
      } catch (e) {
        return false;
      }
    },
    async loadRemission(id) {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const r = await remissionService
          .getRemissionById(id)
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (r.data.success) this.remission = r.data.data;
      } catch (e) {
        return false;
      }
    },
    async signRemission() {
      this.sriModalVisible = false;
      this.$store.dispatch("toggleRequestLoading", {
        text: "Enviando guía de remisión al SRI..."
      });
      try {
        const r = await remissionService
          .sendRemissionSRI({ user_business_remission_id: this.remission.id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        const { success, message, data } = r.data;
        if (success) {
          this.$notifications.success({ message });
        } else {
          this.$notifications.error({ message });
        }
        this.remission = data;
      } catch (e) {
        return false;
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const r = await remissionService
          .updateRemissionStatus({
            user_business_remission_id: this.remission.id
          })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = r.data;
        if (success) {
          this.remission = data;
          this.$notifications.success({ message });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const r = await remissionService
          .deleteRemissionById(this.remission.id)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.deleteModalVisible = false;
          });
        const { success, message } = r.data;
        if (success) {
          this.$notifications.success({ message });
          this.$router.push({ name: "sales.documents" });
        }
      } catch (e) {
        return false;
      }
    },
    async onDocumentSend({ data }) {
      data.append("remission_id", this.remission.id);
      const emailId = `email-remission-${Date.now()}`;
      this.visibleDocumentSend = false;
      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName: this.remission.destination_name,
        documentNumber: `GR #${this.remission.number_remission}`
      });
      try {
        const r = await remissionService.sendRemissionEmail({ data });
        const { success, message } = r.data;
        if (success) {
          signingEventBus.$emit("email:done", { id: emailId });
        } else {
          signingEventBus.$emit("email:error", { id: emailId, message });
        }
      } catch (e) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message: "Error de conexión"
        });
      }
    }
  },
  mounted() {
    const { id } = this.$route.params;
    if (id) this.loadRemission(id);
  }
};
</script>

<style lang="scss" scoped>
.card-quotes-view {
  border-radius: 14px;
  border: 1px solid #e8ecf2;
  box-shadow: 0 2px 12px rgba(49, 53, 92, 0.06);

  .card-quotes-view-header {
    .dvh-desktop {
      padding: 0;
    }
    .dvh-desktop-top {
      display: flex;
      gap: 32px;
      padding: 8px 0 12px;
    }
    .dvh-desktop-identity {
      display: flex;
      align-items: center;
      gap: 24px;
      flex: 1;
    }
    .dvh-desktop-logo {
      flex-shrink: 0;
      img {
        max-height: 60px;
        max-width: 180px;
        object-fit: contain;
        display: block;
        border-radius: 8px;
      }
    }
    .dvh-desktop-identity-info {
      flex: 1;
    }
    .dvh-desktop-sri-col {
      flex: 1;
      border-left: 1px solid rgba(0, 0, 0, 0.06);
      padding-left: 32px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .dvh-desktop-sri-title {
      font-size: 13px;
      font-weight: 600;
      color: #31355c;
      margin: 0;
    }
    .dvh-desktop-doc-number {
      font-size: 16px;
      font-weight: 500;
      color: #31355c;
      margin: 0 0 2px;
    }
    .dvh-desktop-business-name {
      font-size: 13px;
      color: #6b7280;
      margin: 0 0 2px;
    }
    .dvh-desktop-business-detail {
      font-size: 12px;
      color: #6b7280;
      margin: 0;
    }
    .dvh-desktop-divider {
      border: none;
      border-bottom: 1px solid #e8ecf1;
      margin: 16px 0;
    }
    .dvh-desktop-meta-grid {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 16px 24px;
      padding: 4px 0;
    }
    .dvh-desktop-meta-cell {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;
    }
    .dvh-desktop-label {
      font-size: 11px;
      color: #9ca3af;
      display: block;
    }
    .dvh-desktop-value {
      font-size: 14px;
      font-weight: 600;
      color: #31355c;
    }
    .dvh-desktop-sri-row {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 3px;
    }
    .dvh-desktop-sri-code {
      font-size: 11px;
      font-family: monospace;
      word-break: break-all;
      color: #6b7280;
      line-height: 1.5;
    }
    .dvh-desktop-sri-env {
      font-size: 12px;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 10px;
      display: inline-block;
      &.env-prod {
        background: #e4fff4;
        color: #1d9e75;
      }
      &.env-dev {
        background: #fff8e6;
        color: #ba7517;
      }
    }
  }
}

.card-quotes-view-table .table-items-header {
  background: #f5f7fa;
  padding: 8px 12px;
  border-radius: 6px;
}
</style>
